/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Extra cart drawer functions
window.addFreeSampleItem = function(e) {
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const elem = $(e);
    if (elem.hasClass("clicked")) {
      return false;
    }
 
    $(".free-sample-item").addClass("clicked");
    var id = elem.closest(".free-sample-item").attr("data-id");
    var qty = 1;

    if (elem.hasClass("active")) { 
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      return false;
        //qty = 0;
        //cartItemUpdate(id, qty);
    } else { 
      var limit = elem.closest(".sidebar-free-sample-container").attr("data-limit");
      let lists = {};
      if (parseInt(limit) == 1) { 
        $(".free-sample-item").each(function () {
          if ($(this).attr("data-id") != id) {
            $(this).removeClass("active");
            lists[$(this).attr("data-id")] = 0;
          }
        });
      } else {
        var len = $(".free-sample-item.active").length;
        if(parseInt(len) < parseInt(limit)) {
          console.log('true'); 
        } else {
          console.log('false');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          return false;
        }
      }
        $(e).addClass("active");
      
        $.post("/cart/update.js", { updates: lists }).done(function () {
          //console.log(lists);
            items = [];
            var item = {
              quantity: 1,
              id: id,
              properties: { _free_gift_product_sample: 1 },
            }; 
          
            items.push(item);
            $.post("/cart/add.json", {items: items}).done(function () {
                $(".free-sample-item").removeClass("clicked");
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                document.dispatchEvent(new CustomEvent('product:added', {
                   bubbles: true,
                   detail: {
                     variant: id,
                     quantity: 1
                  }
                }));
                // var cartEvent = new CustomEvent("ajaxcart:open", {detail: "cart",});
                // document.dispatchEvent(cartEvent);
            });
        });
    }
    return false;
}

$('body').on('click', '.Cart__Checkout', function (e) {
   e.preventDefault(); 
  var formcartTotal = $("form.Cart").attr("data-cart-total");
  var formamountTotal = $("form.Cart").attr("data-amount-total");
  if(parseInt(formcartTotal) < parseInt(formamountTotal) ) { 
    let lists = {};
    $(".CartItemWrapper.Gift").each(function () {
        lists[$(this).attr("data-variant-id")] = 0;
    });
    $.post("/cart/update.js", { updates: lists }).done(function () {
      //console.log('deleted');
      window.location.href = "/checkout";
    });
  } else {
    window.location.href = "/checkout";
  }
 });

window.sendGiftChanged = function(e) {
  var id = $(e).attr("data-id");
  var chk = $(e).prop("checked");
  console.log(chk);
  if(chk == true){
    items = [];
    var item = {
      quantity: 1,
      id: id,
      properties: { _send_as_gift: 1 },
    }; 
  
    items.push(item);
    $.post("/cart/add.json", {items: items}).done(function () {
       location.reload(); 
    });
  } else {
    let lists = {};
    lists[$(e).attr("data-id")] = 0;
    $.post("/cart/update.js", { updates: lists }).done(function () {
      location.reload(); 
    });
  }
}